import { announcementBar } from './announcementBar';
import { clickOrHoverToOpenMegaNav } from './clickOrHoverToOpenMegaNav';
import { clickToEraseSearch } from './clickToEraseSearch';

const headerInit = () => {
  clickOrHoverToOpenMegaNav('hover');
  clickToEraseSearch();
  announcementBar();
};

export default headerInit;
